<template>
    <div class="schedule-select" v-if="disable">
        <el-date-picker style="flex:3;" v-model="date" type="date" placeholder="select" :clearable="false" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :editable="false"></el-date-picker>
        <hr>
        <el-time-select style="flex:2;" :picker-options="{start: '00:00',step: '00:15',end: '23:45'}" v-model="time" placeholder="select" :clearable="false" :editable="false"></el-time-select>
    </div>
</template>

<script>
export default {
    props: ['disable'],
    components: {
    },
    data: function () {
        return {
            date: null,
            time: null,
        };
    },
    mounted() {
    },
    methods: {
        // 每15分钟向上取整
        getNextQuarterHour() {
            let now = new Date();
            let minutes = now.getMinutes();
            let diffMinutes = Math.ceil(minutes / 15) * 15 - minutes;
            now.setMinutes(now.getMinutes() + diffMinutes);
            if (now.getMinutes() === 60) {
                now.setMinutes(0);
                now.setHours(now.getHours() + 1);
            }
            return now;
        },
        //初始化日期
        initDate(schedules) {
            if(schedules&&schedules.date) {
                this.date = schedules.date;
                this.time = schedules.times[0];
            }else {
                let nowDate = this.getNextQuarterHour();
                let h = nowDate.getHours();
                if (h < 10) {
                    h = '0' + h;
                }
                let m = nowDate.getMinutes();
                if (m < 10) {
                    m = '0' + m;
                }
                let year = nowDate.getFullYear();
                let Month = nowDate.getMonth() + 1;
                let day = nowDate.getDate();
                this.date = year + '-' + Month + '-' + day;
                this.time = h+":"+m;
            }
        },
        //获取当前选中日期
        getRunTime() {
            if(this.date) {
                var date = this.date;
                var time = this.time;
                var schedules = {
                    type: 'Once',
                    date: date,
                    times: [time],
                }
    
                return schedules;
            }
        },
    },
};
</script>

<style scoped>
.once-des-position {
    margin-left: 5px;
    /*no*/
    margin-right: 10px;
    /*no*/
    float: left;
}

.schedule-select {
    display: flex;
    flex-direction: row;
}

hr {
    border: none;
    border-top: 1px solid #C1CBE3;/*no*/
    margin: 15px 10px;/*no*/
    width: 10px;/*no*/
}

.schedule-select >>> .el-picker-panel__icon-btn {
    margin-top: 0;
}

.schedule-select >>> .el-picker-panel__icon-btn:hover {
    color: #5065BB;
    background: #E8ECFA;
}
</style>



// WEBPACK FOOTER //
// src/components/common/tabs/tabs_transfer_schedule/tab_once.vue